export const RESET = 'ROLE_UPDATE_RESET'
export const SET_ERROR = 'ROLE_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'ROLE_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'ROLE_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'ROLE_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'ROLE_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'ROLE_UPDATE_UPDATE_RETRIEVED'
